export const CREATE_NEW_CANDIDATE = 'CREATE_NEW_CANDIDATE'
export const CREATE_NEW_CANDIDATE_PENDING = 'CREATE_NEW_CANDIDATE_PENDING'
export const CREATE_NEW_CANDIDATE_FULFILLED = 'CREATE_NEW_CANDIDATE_FULFILLED'
export const CREATE_NEW_CANDIDATE_REJECTED = 'CREATE_NEW_CANDIDATE_REJECTED'

export const UPDATE_NEW_CANDIDATE = 'UPDATE_NEW_CANDIDATE'
export const UPDATE_NEW_CANDIDATE_PENDING = 'UPDATE_NEW_CANDIDATE_PENDING'
export const UPDATE_NEW_CANDIDATE_FULFILLED = 'UPDATE_NEW_CANDIDATE_FULFILLED'
export const UPDATE_NEW_CANDIDATE_REJECTED = 'UPDATE_NEW_CANDIDATE_REJECTED'

export const ASSETMANAGER_BULK_UPLOAD_RESUMES_POST = 'ASSETMANAGER_BULK_UPLOAD_RESUMES_POST'
export const ASSETMANAGER_BULK_UPLOAD_RESUMES_POST_PENDING =
  'ASSETMANAGER_BULK_UPLOAD_RESUMES_POST_PENDING'
export const ASSETMANAGER_BULK_UPLOAD_RESUMES_POST_FULFILLED =
  'ASSETMANAGER_BULK_UPLOAD_RESUMES_POST_FULFILLED'
export const ASSETMANAGER_BULK_UPLOAD_RESUMES_POST_REJECTED =
  'ASSETMANAGER_BULK_UPLOAD_RESUMES_POST_REJECTED'

export const RESET_RESUMES_STATUS = 'RESET_RESUMES_STATUS'
